import { ChatChannelService } from '../types/services/chat';
import { StorageChatService } from '../types/services/chat/StorageChatService';
import { StorageEventService } from '../types/services/event/StorageEventService';
import { StorageHelpService } from '../types/services/help/StorageHelpService';
import { StorageListingService } from '../types/services/listing/StorageListingService';
import { StorageNewsAssetService, StorageNewsService } from '../types/services/news/StorageNewsService';
import { StorageUserService } from '../types/services/user/StorageUserService';
import { ConsoleLogger } from '../types/utils/logger';
import { EventFEService } from './event';
import { rtdb, storage } from './firebase';
import { ListingFEService } from './listing';
import { ClientStorageAdapter } from './StorageFEService';
import { UserFEService } from './user';

/** Generate a file name from a file */
export const generateFileName = (file: File) => `${file.name}_${Date.now()}`;

export const StorageListingFEService = (listingId: string) =>
    new StorageListingService(
        listingId,
        new ListingFEService(),
        new ClientStorageAdapter(storage),
        new ConsoleLogger()
    )

export const StorageUserFEService = (userId: string) =>
    new StorageUserService(
        userId,
        new UserFEService(),
        new ClientStorageAdapter(storage),
        new ConsoleLogger()
    )

export const StorageEventFEService = (eventId: string) =>
    new StorageEventService(
        eventId,
        new EventFEService(),
        new ClientStorageAdapter(storage),
        new ConsoleLogger()
    )

export const StorageNewsFEService = (storyId: string) =>
    new StorageNewsService(
        storyId,
        new ClientStorageAdapter(storage),
        new ConsoleLogger()
    )
export const StorageNewsAssetFEService = (storyId: string) =>
    new StorageNewsAssetService(
        storyId,
        new ClientStorageAdapter(storage),
        new ConsoleLogger()
    )

export const StorageChatFEService = (channelId: string) =>
    new StorageChatService(
        channelId,
        new ChatChannelService(rtdb),
        new ClientStorageAdapter(storage),
        new ConsoleLogger()
    )

export const StorageHelpFEService = (articleId: string) =>
    new StorageHelpService(
        articleId,
        new ClientStorageAdapter(storage),
        new ConsoleLogger()
    )